import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-empty-list',
    templateUrl: './empty-list.component.html',
    styleUrls: ['./empty-list.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EmptyListComponent implements OnInit {

  constructor() { }

  @Input() message: string = "Não encontramos dados para a pesquisa realizada.";

  ngOnInit(): void {
  }

}
